/* Cupsona: "Customize Your Cup" button on product cards (user, 2026-10-29).
   Cards of products in the Custom Cups collection get a button under the
   price that deep-links to the product page with the editor auto-opened
   (?customize=1). The collection's product list is the single source of
   truth — a cup joins automatically when it is added to the collection. */
(() => {
  const CSS = '.ce-card-btn{display:block;position:relative;z-index:2;margin-top:10px;background:#05575B;color:#fff;' +
    'text-align:center;text-decoration:none;font-weight:700;font-size:15px;border-radius:10px;padding:12px 14px}' +
    '.ce-card-btn:hover{background:#04474B}';
  function addButtons(handles) {
    document.querySelectorAll('product-card').forEach(card => {
      if (card.dataset.ceBtn) return;
      const link = card.querySelector('a.product-card__link') || card.querySelector('a[href*="/products/"]');
      if (!link) return;
      const m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (!m || !handles[m[1]]) return;
      card.dataset.ceBtn = '1';
      if (!document.getElementById('ce-card-css')) {
        const st = document.createElement('style');
        st.id = 'ce-card-css'; st.textContent = CSS;
        document.head.appendChild(st);
      }
      const btn = document.createElement('a');
      btn.className = 'ce-card-btn';
      btn.href = '/products/' + m[1] + '?customize=1';
      btn.textContent = 'Customize';
      const host = card.querySelector('.product-card__content') || card;
      host.appendChild(btn);
    });
  }
  fetch('/collections/custom-cups/products.json?limit=250')
    .then(r => r.json())
    .then(j => {
      const handles = {};
      (j.products || []).forEach(p => { handles[p.handle] = 1; });
      addButtons(handles);
      new MutationObserver(() => addButtons(handles))
        .observe(document.body, { childList: true, subtree: true });
    })
    .catch(() => {});
})();
